import React from 'react';
import { graphql, compose } from 'react-apollo';
import { ToastContainer } from 'react-toastr';
import Banner from '../../../../components/Banner/index';
import Footer from '../../../../components/Footer/index';
import Form from '../Form';
import THEATER_DETAILS_QUERY from '../../../../graphql/TheaterDetails';
import EDIT_THEATER_MUTATION from '../../../../graphql/EditTheater';
import { IsAdmin } from '../../../../utils/Roles';

class EditTheater extends React.PureComponent {
  handleTheaterEdition = (theater) => {
    const { mutate, history, match } = this.props;
    const theaterProps = {
      ...theater,
      id: match.params.theaterId,
    };

    mutate({
      variables: theaterProps,
    })
      .then(({ data }) => {
        this.toastr.success('Teatro editado correctamente');
        if (IsAdmin()) {
          setTimeout(() => {
            history.push('/admin/theaters');
          }, 2000);
        } else {
          window.scrollTo(0, 0);
        }
      })
      .catch((err) => {
        this.toastr.error('Ocurrió un error al intentar editar el teatro');
      });
  };

  render() {
    return (
      <div>
        <Banner />
        <ToastContainer
          ref={(ref) => { this.toastr = ref; }}
          className="toast-top-right"
        />
        <div className="properties-details-page">
          <div className="container">
            <div className="row">
              <div className="col-md-1" />
              <div className="col-md-10 new-form-container">
                <div className="submit-address">
                  {this.props.theater ? (
                    <Form
                      title="Editar teatro"
                      onSubmit={this.handleTheaterEdition}
                      theater={this.props.theater}
                    />
                  ) : (
                    <div />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withMutation = graphql(EDIT_THEATER_MUTATION);


const withDetails = graphql(THEATER_DETAILS_QUERY, {
  options: ({ match }) => ({
    fetchPolicy: 'network-only',
    variables: {
      id: match.params.theaterId,
    },
  }),
  props: ({ data }) => ({
    loading: data.loading,
    theater: data.theater,
  }),
});
export default compose(withDetails, withMutation)(EditTheater);



// WEBPACK FOOTER //
// ./src/containers/Admin/Theater/Edit/index.js